import { Component, Input, OnInit } from '@angular/core';
import { ModulemanagementService } from '../services/modules/modulemanagement.service';
import { ComponentheaderService } from '../services/componentheader.service';

@Component({
  selector: 'app-coursecalendarcard',
  templateUrl: './coursecalendarcard.component.html',
  styleUrls: ['./coursecalendarcard.component.css'],
})
export class CoursecalendarcardComponent implements OnInit {

  courses: any[] = [];
  page = 1;
  pageSize = 10;
  loading = false;
  hasMore = true;
  constructor(private moduleManager: ModulemanagementService, private headerinfo: ComponentheaderService) {
  }
  async ngOnInit(): Promise<void> {
    // This page set no header, so it inherited whatever the previously visited page left
    // behind — including that page's breadcrumbs.
    this.headerinfo.setHeaderDisplay('Course Calendar',
      [{ displaytext: 'Course Calendar', route: '/site/coursescalendar' }], []);
    await this.loadData();
  }
  async loadData() {
    if (this.loading || !this.hasMore) return;
    this.loading = true;
    try {
      const newData: any = await this.moduleManager.getCourseCalendarInfo(this.pageSize, this.page).toPromise();

      if (newData.length < this.pageSize)
        this.hasMore = false;
      
      this.courses = [...this.courses, ...newData];
      this.page++;
    } finally {
      this.loading = false;
    }
  }

  async onScroll(event: any) {
    const element = event.target;
    const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 50;

    if (atBottom) {
      await this.loadData();
    }
  }
}
